<header *ngIf="isMobile" class="shadow" id="portal-header-mob">
  <nav class="navbar navbar-expand-lg navbar-dark navbar-link-underline bg-primary">
    <div class="container-xl justify-content-center">
      <img alt="MyLabcorp" class="branding" height="40" src="assets/images/logo-patient-white.svg" />
    </div>
  </nav>
</header>
<header *ngIf="!isMobile" class="shadow" id="portal-header-reg">
  <div class="bg-white shadow d-none d-lg-block">
    <div class="container-xl d-flex justify-content-end">
      <div class="btn-group" role="group" aria-label="Basic example">
        <a href="https://www.labcorp.com/trials" class="p-1 mx-3" target="_blank">Learn About Clinical Trials</a>
        <a class="p-1 mx-3" href="{{ onDemandUrl + '/sales/order/history/' }}" target="_blank">View OnDemand Orders</a>
        <a routerLink="ondemand" class="p-1 mx-3">
          <span>Purchase Your Own Lab Test</span>
        </a>
        <a [href]="helpCenterUrl" class="p-1 mx-3" target="_blank">Help Center</a>
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg navbar-dark navbar-link-underline bg-primary">
    <div class="container-xl justify-content-start">
      <button
        class="navbar-toggler"
        type="button"
        (click)="isMenuCollapsed = !isMenuCollapsed"
        aria-controls="lcGradientNavbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="material-icons-round icon-lg">menu</i>
      </button>
      <a class="navbar-brand img" (click)="isMenuCollapsed = true" routerLink="/portal/dashboard"
        ><img alt="MyLabcorp" class="branding" height="40" src="assets/images/logo-patient-white.svg"
      /></a>
      <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse" id="lcGradientNavbarContent">
        <ul class="navbar-nav m-auto">
          <li class="nav-item">
            <a
              class="nav-link"
              data-testid="nav-dashboard-link"
              data-label="Dashboard"
              routerLink="{{ navigatedFrom ? 'portal/dashboard' : 'dashboard' }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Dashboard</span></a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-testid="nav-appointments-link"
              data-label="Appointments"
              routerLink="{{ navigatedFrom ? 'portal/appointments' : 'appointments' }}"
              routerLinkActive="active"
              (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Appointments</span></a
            >
          </li>

          <li class="nav-item desktop-nav">
            <a
              class="nav-link lab-orders-lbl"
              data-testid="nav-orders-link"
              data-label="Orders"
              routerLink="{{ navigatedFrom ? 'portal/orders' : 'orders' }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Lab Orders</span></a
            >
          </li>
          <li class="nav-item mobile-nav">
            <a class="nav-link" data-label="Orders" routerLink="orders" (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Lab Orders</span></a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-testid="nav-results-link"
              data-label="Results"
              routerLink="{{ navigatedFrom ? 'portal/results/list' : 'results/list' }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Results</span></a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-testid="nav-invoices-link"
              data-label="Billing"
              routerLink="{{ navigatedFrom ? 'portal/invoices' : 'invoices' }}"
              routerLinkActive="active"
              (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Billing</span></a
            >
          </li>
        </ul>
        <ul class="navbar-nav d-block d-lg-none">
          <li class="nav-item desktop-nav">
            <a
              class="nav-link"
              data-label="Learn About Clinical Trials"
              href="https://www.labcorp.com/trials"
              (click)="isMenuCollapsed = true"
              target="_blank"
              ><span class="nav-link-label">Learn About Clinical Trials</span></a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-label="View OnDemand Orders"
              href="{{ onDemandUrl + '/sales/order/history/' }}"
              (click)="isMenuCollapsed = true"
              target="_blank"
              ><span class="nav-link-label">View OnDemand Orders</span></a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-label="Purchase Your Own Lab Test" routerLink="ondemand" (click)="isMenuCollapsed = true"
              ><span class="nav-link-label">Purchase Your Own Lab Test</span></a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-label="Help Center" [href]="helpCenterUrl" (click)="isMenuCollapsed = true" target="_blank"
              ><span class="nav-link-label">Help Center</span></a
            >
          </li>
        </ul>
        <ul class="navbar-nav">
          <li ngbDropdown #dropdown="ngbDropdown" (keydown.enter)="toggleDropdown(dropdown)" class="nav-item me-0">
            <a class="nav-link" data-testid="nav-profile-link" tabindex="0" ngbDropdownToggle role="button" id="userGradientNavbarDropdown">
              <span class="badge badge-username">{{ pahAbbreviation | uppercase }}</span>
              <span class="nav-link-wrapper" [attr.data-label]="pahName | uppercase">
                <span class="nav-link-label">{{ pahName }}</span>
              </span>
            </a>
            <div ngbDropdownMenu aria-labelledby="userGradientNavbarDropdown" class="dropdown-menu dropdown-menu-right">
              <a
                ngbDropdownItem
                routerLink="{{ navigatedFrom ? 'portal/account/profile' : 'account/profile' }}"
                (click)="isMenuCollapsed = true"
                (keydown.enter)="navigateTo('portal/account/profile')"
                >Profile</a
              >
              <a
                ngbDropdownItem
                routerLink="{{ navigatedFrom ? 'portal/account/linked-accounts' : 'account/linked-accounts' }}"
                (click)="isMenuCollapsed = true"
                (keydown.enter)="navigateTo('portal/account/linked-accounts')"
                >Linked Accounts</a
              >
              <a ngbDropdownItem tabindex="0" (keydown.enter)="signOut($event)" (click)="signOut($event)" style="cursor: pointer"
                >Sign Out</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
